<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M0 12C0 15.1826 1.26428 18.2348 3.51472 20.4853C5.76516 22.7357 8.8174 24 12 24C15.1826 24 18.2348 22.7357 20.4853 20.4853C22.7357 18.2348 24 15.1826 24 12C24 8.8174 22.7357 5.76516 20.4853 3.51472C18.2348 1.26428 15.1826 0 12 0C8.8174 0 5.76516 1.26428 3.51472 3.51472C1.26428 5.76516 0 8.8174 0 12Z" fill="white"/>
        <path d="M12 6.54492V17.454" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12 6.54492V17.454" stroke="#2168BC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M17.455 12H6.5459" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M17.455 12H6.5459" stroke="#2168BC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>
<script>
const addParkingConfirmIcon = {
    name: 'addParkingConfirmIcon',
}
export default addParkingConfirmIcon
export { addParkingConfirmIcon }
</script>
